import { Component } from '@angular/core';

@Component({
  selector: 'edit-from-board-svg',
  templateUrl: './edit-from-board.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class EditFromBoardSvgComponent  {}